import React from "react";
import { AILogoIcon, EditMessageIcon } from "../../../assets/images/svg";
import Feedback from "./Feedback";
import AIError from "./AIError";
import { NO_DATA_MESSAGE } from "../../../app_constants";
import ChartBlock from "../../../components/charts/ChartBlock/ChartBlock";
import TableBlock from "./TableBlock";
import HeatmapBlock from "./HeatmapBlock";
import { linkifyClientIds } from "../../../utils/linkifyClientIds";

const formatHtml = (string = "") => {
  let html = string.replace(/<br\s*\/?>/gi, "");
  html = html.replace(/<table/g, "<table class='table' border='1'");
  html = html.replace(/<p>/, "<p><strong>").replace(/<\/p>/, "</strong></p>");
  html = linkifyClientIds.linkifyHtml(html);
  return html;
};

// const ClickableText = ({ html, onClickItem }) => {
//   const handleClick = useCallback((e) => {
//     const li = e.target.closest("li");
//     if (!li) return;
//
//     // Only handle leaf <li> elements (no nested <ul> children)
//     if (li.querySelector("ul")) return;
//
//     const text = li.textContent.trim();
//     if (text && onClickItem) onClickItem(text);
//   }, [onClickItem]);
//
//   return (
//     <div
//       className="message-text clickable-items"
//       dangerouslySetInnerHTML={{ __html: formatHtml(html) }}
//       onClick={handleClick}
//     />
//   );
// };

const MixedContent = ({ response, messageId }) => (
  <div className="message-text">
    {response.map((block, i) =>
      block.type === "chart" ? (
        <ChartBlock key={i} chart={block.content} chartId={`${messageId}-${i}`} />
      ) : block.type === "table" ? (
        <TableBlock key={i} table={block.content} />
      ) : block.type === "heatmap" ? (
        <HeatmapBlock key={i} heatmap={block.content} />
      ) : (
        <div key={i} dangerouslySetInnerHTML={{ __html: formatHtml(block.content || "") }} />
      )
    )}
  </div>
);

const AgentResponse = ({ response, messageId }) => {
  if (Array.isArray(response)) {
    return <MixedContent response={response} messageId={messageId} />;
  }

  return (
    <div className="message-text" dangerouslySetInnerHTML={{ __html: formatHtml(response) }} />
  );
};

const Message = ({ messageItem, setInputMessage, pageName }) => {
  const { id, response, who, feedback } = messageItem;
  const isAgent = who === "agent";

  if (response === "") return <AIError errorText={NO_DATA_MESSAGE} />;

  if (!response) return null;

  return (
    <div className={`message-wrapper ${isAgent ? "" : "user"}`}>
      <div className="message">
        {isAgent ? (
          <>
            <AILogoIcon className="ai-logo-icon" />
            <AgentResponse response={response} messageId={id} />
            {/* onClickItem={summary && typeof response === "string" && /I can help analyze/i.test(response) ? handleClickItem : null} */}
          </>
        ) : (
          <>
            <div className="message-text">{`"${response}"`}</div>
            <EditMessageIcon className="message-edit" onClick={() => setInputMessage(response)} />
          </>
        )}
      </div>

      {isAgent && <Feedback feedback={feedback} message={response} id={id} pageName={pageName} />}
    </div>
  );
};

export default Message;
